import {
  ListingHistoryActionTypes,
  ListingHistoryState,
  SET_LISTING_HISTORY_DATA,
  SET_LISTING_HISTORY_ERROR,
  SET_LISTING_HISTORY_LOADING,
} from 'store/listingHistory/types';

export const initialState: ListingHistoryState = {
  loading: false,
  data: [],
  error: null,
};

export default function listingHistoryReducer(
  state = initialState,
  action: ListingHistoryActionTypes
): ListingHistoryState {
  switch (action.type) {
    case SET_LISTING_HISTORY_DATA: {
      const { data } = action;
      return {
        data,
        loading: false,
        error: null,
      };
    }
    case SET_LISTING_HISTORY_LOADING: {
      const { loading } = action;
      return {
        ...state,
        loading,
      };
    }
    case SET_LISTING_HISTORY_ERROR: {
      const { error } = action;
      return {
        data: [],
        loading: false,
        error,
      };
    }
    default:
      return state;
  }
}
